import CreditsPage from '../ui/pages/CreditsPage';

export default CreditsPage;
